module.exports = __webpack_public_path__ + "static/media/blog3.6b077703.png";